import React from "react";
import styles from "./StudentFormSwitcher.module.css";

const StudentFormSwitcher = ({ handleToggleForm, showForm }) => {
  return (
    <div className="text-center mb-4">
      <div className={`btn-group ${styles.switcherGroup}`} role="group">
        <button
          type="button"
          onClick={handleToggleForm}
          className={`${styles.switcherButton} ${
            showForm === "internship" ? styles.active : ""
          }`}
          style={{ cursor: "pointer" }}
        >
          <i className="feather-user"></i>
          <span style={{fontSize : '1.2rem'}}>Apply For Internship</span>
        </button>
        <button
          type="button"
          onClick={handleToggleForm}
          className={`${styles.switcherButton} ${
            showForm === "resources" ? styles.active : ""
          }`}
          style={{ cursor: "pointer" }}
        >
          <i className="feather-book-open"></i>
          <span style={{fontSize : '1.5rem'}}>Browse Resources</span>
        </button>
      </div>
    </div>
  );
};

export default StudentFormSwitcher;
